import { Edit ,Download, PropaneSharp} from "@mui/icons-material";
import '../pages/adminManagement/adminManage.scss'
import {utils,writeFile} from "xlsx";
import { useState } from "react";
import { FormControl, InputLabel, MenuItem, Select, TextField,CircularProgress } from "@mui/material";
import { Link as RouterLink, useNavigate,useLocation } from "react-router-dom";
import { FilterBtn, BtnSecondary, BtnPrimary } from "../components/buttons";
import {format} from 'date-fns'
import axios from "axios";
import toastr from "toastr";
import DynamicDataValue from "../pages/formPages/dynamicDataValue";
const TableFeatures = (props)=>{
    
    const {state} = useLocation;
    const [loading,setLoading] = useState(false);
    //console.log(props)
    // const {} = props
   
    const changeHandlerSort = ({target:{name,value}})=>{
        switch (name) {

            case 'sortFieldName':

                props.setSortFieldName(value);

                //client-side sorting
                if(props.responseLength<1000){
                
                    props.selectItems.forEach((item)=>{
                        
                            if(value===item.value){
                                   
                                let sortedArr = props.dbEntries.sort((a,b)=>{
                    
                                    if( a[item.value]>b[item.value]){
                                     
                                     return 1
                                    }
                                    if( a[item.value]<b[item.value]){
                                     return -1
                                    }
         
                                    return 0
                                 })
                    
                                 props.setDbEntries([...sortedArr])
                                    
                            }
                        
                    })
                }

                    break;

            case 'sortOrder':

                props.setSortOrder(value);

                if(props.responseLength<1000){
                    switch (value) {
                        case -1:
                            let ascending = props.dbEntries.reverse()
                            //console.log(ascending)
                            props.setDbEntries([...ascending]) 
                            return;
                            break;
                        
                            case 1:
                           let descending = props.dbEntries.reverse()
                            //console.log(descending)
                            props.setDbEntries([...descending])
                            break;
                    
                        default:
                            break;
                    }}
                
                break;
        
            default:
                break;
        }
    }
  

    const dowloadAsXlsx = async()=>{
        setLoading(true)

        let mapArr;
      if( props.show.downloadOffline){
     mapArr = props.dbEntries
        setLoading(false)

  }
      else{  
           
      

        try {
            let response = await axios.post(props.apiGETLink,{...props.apiBODY},{params:{...props.apiParams,download:true}})
            console.log(response,"entry")
            if(props.apiGETLink===`${process.env.REACT_APP_API_LINK}/user/getUsers`){
                // const date = new Date();
                // let aTag = document.createElement('a')
                // let blob = new Blob([response.data],{ type: 'text/csv' })
                // aTag.download = `${props.downloadXlsxFileName}_${format(date,'dd/MMM/yyyy')}.csv`
                // aTag.href = window.URL.createObjectURL(blob)
                // aTag.click()

                mapArr = response.data
            }else{
                if(response.data.dataLength<=0) return 
    
                mapArr = response.data.dbEntries
            }
           
            setLoading(false)

        } 
        
        catch (error) {
            //console.log(error);
             return toastr.error("Error downloading data.")
        }


    }

    let downloadArr = mapArr.map((entry,index)=>{
        // console.log(entry,"entry")
        entry = {srNum :index+1,
            ...entry,
             date : entry.whenentered?  new Date(entry.whenentered).toLocaleDateString("en-US", {
            day: "numeric",
          }) +
            "-" +
            new Date(entry.whenentered).toLocaleDateString("en-US", {
              month: "short",
            }) +
            "-" +
            new Date(entry.whenentered).toLocaleDateString("en-US", {
              year: "numeric",
            }):"",
        time:  entry.whenentered? `${new Date(entry.whenentered).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`:"",
         
        
       }
       entry.isactive =entry.isactive?entry.isactive===1?"Yes":"No":""
            if(props.apiGETLink===`${process.env.REACT_APP_API_LINK}/user/getUsers`){
                entry.isemailverified =entry.isemailverified?entry.isemailverified===1?"Yes":"No":"No"
                entry.isactive =entry.isactive?entry.isactive===1?"Yes":"No":"No"
                entry.otp =entry.otp?entry.otp!==""?"Yes":"No":"No"
                entry.city =entry.city?entry.city:""
                entry.state =entry.state?entry.state:""
                // entry.isactive =entry.isactive?entry.isactive===1?"Yes":"No":"No"
                entry.password =entry.password?"Yes":"No"
                entry["GA_Campaign"] = entry.GACampaign?entry.GACampaign:"";
                entry["Last Viewed Date"] = entry && entry.lastvideoviewedon?  new Date(entry.lastvideoviewedon).toLocaleDateString("en-US", {
                    day: "numeric",
                  }) +
                    "-" +
                    new Date(entry.lastvideoviewedon).toLocaleDateString("en-US", {
                      month: "short",
                    }) +
                    "-" +
                    new Date(entry.lastvideoviewedon).toLocaleDateString("en-US", {
                      year: "numeric",
                    }):""
                    entry["Last Viewed Time"] = entry && entry.lastvideoviewedon? `${new Date(entry.lastvideoviewedon).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`:""
                    entry["Videos Viewed"] = entry && entry.videosviewed?entry.videosviewed:""

                function getInterest(intArray,intString="") {
                    if(intArray.length<=0){
                        
                        return intString
                    }
                    // //console.log(intArray,intString)
                    
                    let interest = intArray.shift()
                    // //console.log(interest.interests)
                    if(intArray.length<=0){
                        intString =intString + interest.interests
                    }else{
                        intString =intString + interest.interests +","
                    }

                    
                    return getInterest(intArray,intString)
                }
                entry.interest = getInterest(entry.interest)
                
               delete entry.videosviewed;
                delete entry.lastvideoviewedon;
                delete entry.GACampaign;
            }

            if(props.apiGETLink===`${process.env.REACT_APP_API_LINK}/admin/getCourses`){
                // //console.log(entry.comments.length);
                entry["Video Category"] = entry.type === 1 ? "Course" : "Single" 
                entry.speakertype = entry.speaker === 1 ? "Static speaker" : "Create speaker" 
                // entry.comments =entry.comments.length
                entry["website link"] = `https://www.onference.in/c/${
                                entry.coursename
                                  .toString()
                                  .toLowerCase()
                                  .replace(/ /g, "-")
                                  .replace(/[^\w-]+/g)
                                  .replace(/-{2,}/g, "-") +
                                "/" +
                                entry.urlid
                              }`
               entry["Course ID"] = entry._id?entry._id:""
                entry["Video Name"] = entry.coursename?entry.coursename:""
                entry["Speaker Name"] = entry.speakername?entry.speakername:""
                entry["Duration"] = entry.durationofcourse?entry.durationofcourse:""
                entry["Speaker Name"] = entry.speakername?entry.speakername:""
                entry["Price"] = entry.registrationcost?entry.registrationcost:""
                entry["Topic Name"] = entry.coursetopicname?entry.coursetopicname:""
                entry["Total Enroll Form Count"] = entry.totalcmeformcount?entry.totalcmeformcount:0
                entry["No. of Users Enrolled"] = entry.numberofuserenrolled?entry.numberofuserenrolled:0
                entry["No. of Views"] = entry.totalviews?entry.totalviews:0
                entry["Is CME Form"] = entry?.cmeForm  
                entry.videoType = (entry.registrationcost == "0" && entry.isprepaid == 0)?"Unpaid":(entry.registrationcost !== "0" && entry.isprepaid == 0)?"Paid":(entry.isprepaid == 1)?"Redeemable" :"";
                
                delete entry._id;
                delete entry.coursename;
                delete entry.speakername;
                delete entry.durationofcourse;
                delete entry.speakername;
                delete entry.registrationcost;
                delete entry.coursetopicname;
                delete entry.totalcmeformcount;
                delete entry.numberofuserenrolled;
                delete entry.totalviews;
                delete entry.cmeForm;
                delete entry.isprepaid;
            }
            if(props.apiGETLink===`${process.env.REACT_APP_API_LINK}/admin/Getpayoutdetails`){
                console.log(entry,"entryentrymmmmmmmmmmmm");
                    entry["Course ID"] = entry.courseid?entry.courseid:""
                    entry["Course Name"] = entry.coursename?entry.coursename:""
                    entry["User ID"] = entry.userid?entry.userid:""
                    entry["Name"] = entry.fullname?entry.fullname:""
                    entry["Email"] = entry.email?entry.email:""
                    entry["Mobile"] = entry.mobileno?entry.mobileno:""
                    entry["City"] = entry.city?entry.city:""
                    // entry["Interests"] = entry.interests?entry.interests:""
                    entry["State"] = entry.state?entry.state:""
                    entry["Country"] = entry.country?entry.country:""
                    entry["Medical Council No"] = entry.MRegorStudentId?entry.MRegorStudentId:""

                    entry["Payment Date"] = entry.whenentered?  new Date(entry.whenentered).toLocaleDateString("en-US", {
                        day: "numeric",
                      }) +
                        "-" +
                        new Date(entry.whenentered).toLocaleDateString("en-US", {
                          month: "short",
                        }) +
                        "-" +
                        new Date(entry.whenentered).toLocaleDateString("en-US", {
                          year: "numeric",
                        }):""

                    entry["Payment Time"] = entry.whenentered? `${new Date(entry.whenentered).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`:""


                    // entry["Payment Source (Website/Android/iPhone)"] = entry.paymentmethod?entry.paymentmethod:"";
                    // entry["Payment Source (Website/Android/iPhone)"] = entry.devicetype?entry.devicetype === 0?"iPhone":entry.devicetype === 1?"Android":entry.devicetype === 2?"Website":"":"";
                    const deviceMap = { 0: "iPhone", 1: "Android", 2: "Website" };
                    entry["Payment Source (Website/Android/iPhone)"] = deviceMap[entry.devicetype] || "";
                    entry["Payment Method (UPI etc/ In-App Purchase)"] = ""
                    entry["Gross Amount"] = entry.amountpaid?entry.amountpaid :""

                    entry["Order_ID"] = entry.transactionid?entry.transactionid:""
                    entry["Invoice Number"] = entry.invoicenum?entry.invoicenum:""
                    entry["Discount Code"] = entry.couponcode?entry.couponcode:""
                
                    entry["Discount Amount"] = entry.discountamount? entry.discountamount :""
                    entry["Currency Type"] = entry.currencytype? entry.currencytype :""
                    // entry["Campaign Name"] = entry.gacampaign ? entry.gacampaign :""
                    entry["Campaign Name"] = entry.gacampaign ? entry.gacampaign :entry.devicetype === 0?"iPhone Purchase":entry.devicetype === 1?"Android Purchase":""
        
                
                 
                    delete entry.courseid;
                    delete entry.coursename;
                    delete entry.userid;
                    delete entry.fullname;
                    delete entry.email;
                    delete entry.mobileno;
                    delete entry.city;
                    delete entry.state;
                    delete entry.country;
                    delete entry.MRegorStudentId;
                    delete entry.whenentered;
                    delete entry.paymentmethod;
                    delete entry.amountpaid;
                    delete entry.transactionid;
                    delete entry.invoicenum;
                    delete entry.discountamount;
                    delete entry.gacampaign;
                    delete entry.isactive;
                    delete entry.couponcode;
                    delete entry.devicetype;
                    delete entry.currencytype;
                   

            }
            if(props.apiGETLink&&props.apiGETLink.split("/")[4]===`getdownloadenroll`){
                // //console.log(entry.comments.length);
                entry["Registered_Time"] =entry.Registered_Time?`${new Date(entry.Registered_Time).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`:""
                entry["Registered_Date"] =entry.Registered_Date? new Date(entry.Registered_Date).toLocaleDateString("en-US", {
                    day: "numeric",
                  }) +
                    "-" +
                    new Date(entry.Registered_Date).toLocaleDateString("en-US", {
                      month: "short",
                    }) +
                    "-" +
                    new Date(entry.Registered_Date).toLocaleDateString("en-US", {
                      year: "numeric",
                    }):""
                entry["Payment_Date"] =entry.Payment_Date? new Date(entry.Payment_Date).toLocaleDateString("en-US", {
                    day: "numeric",
                  }) +
                    "-" +
                    new Date(entry.Payment_Date).toLocaleDateString("en-US", {
                      month: "short",
                    }) +
                    "-" +
                    new Date(entry.Payment_Date).toLocaleDateString("en-US", {
                      year: "numeric",
                    }):""
                
            }

        // entry.srNum = Number(entry.srNum)+1
        // console.log(window.location.pathname)
    if(window.location.pathname==="/total-registrations"){
        delete entry.userid
        delete entry.courseid
    }
 delete entry.__v;
 !entry.whenentered&& delete entry.date
 !entry.whenentered&& delete entry.time
 delete entry.whenentered;
 delete entry.srNum;
 return entry
 })
  
 const myHeader = [ "_id", "fullname", "email", "isemailverified", "countrycode", "mobileno", "facebookid", "googleplusid", "address", "isactive", "qualification", "interest",  "registeredfrom", "version", "country","city", "state","MRegorStudentId", "StateMedicalCouncil", "otp", "password"];

    const workSheet = utils.json_to_sheet(downloadArr,props.apiGETLink ===`${process.env.REACT_APP_API_LINK}/user/getUsers`? {header: myHeader}:{});
    const workBook = utils.book_new();
    const date = new Date();
    utils.book_append_sheet(workBook,workSheet,'Sheet1');
    writeFile(workBook,`${`${props.downloadXlsxFileName}_${format(date,'dd/MMM/yyyy')}.csv`}`);
        // writeFile(workBook,`${`${props.downloadXlsxFileName}_${date.toLocaleDateString()}.csv`}`);
     };

    return(
        <div className="more-features">
        {/* <div className="total">
            {props.show.total && <p>{`TOTAL : ${props.total}`}</p>}
            
        </div> */}
        <div className="total">
      { props.show.total && <h3>{`Existing Total : ${props.total}`}</h3>}
        </div>
        { props.showPayoutStatusCount && <div className="total videoApprovalStatus">
        <h3><DynamicDataValue currentStatus = {"failed"} count={props.failedDataLength?props.failedDataLength:""} /></h3>
        </div>}

        {props.showSortOrder &&
        <div className="sort">
            <FormControl sx={{minWidth:100}} size="small">
                    <InputLabel>Sort by:</InputLabel>
                <Select
                
                label="sort by:"
                name="sortFieldName"
            
                onChange={changeHandlerSort}
                value={props.sortFieldName}
                >
                   {props.selectItems.map((item)=>{
                    if(item.isSort===false)return
                            return(
                                <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                            )
                        })
                    }
                </Select>
                </FormControl>
            <FormControl sx={{minWidth:100}} size="small">
                    <InputLabel>Sort order</InputLabel>
                <Select
                
                label="sort order"
                name="sortOrder"
                onChange={changeHandlerSort}
                value={props.sortOrder}
                >
                    <MenuItem value={-1}>Ascending</MenuItem>
                    <MenuItem value={1}>descending</MenuItem>
                </Select>
                </FormControl>
        </div> }
        <div className="feature-btns">
            
               {props.show.downloadBtn && <BtnSecondary action={()=>{dowloadAsXlsx()}}>
                   
                   <>
                   <Download/>DOWNLOAD
                   {loading&&<CircularProgress color="inherit" style={{marginLeft:"4px"}} size={20} />}
                   </>
                </BtnSecondary>}
            
            {props.show.addBtn && <RouterLink to={props.formLink} state={{title:props.linkPageTitle,showScheduleField:props.showScheduleField,dBFields:props.selectItems,apiPOSTLink:props.apiPOSTLink,apiPATCHLink:props.apiPATCHLink}}>
                <BtnSecondary style={{height:"39px"}}>
                ADD
                </BtnSecondary>
            </RouterLink>}
        </div>
    </div>
    )
}

TableFeatures.defaultProps = {
    show:{total:true,downloadBtn:true,addBtn:true,showSortOrder:true,downloadOffline:false},
    showSortOrder:true
}


export default TableFeatures